import React, { useEffect, useState } from 'react';
import I18n from 'i18n-js';
import { withRouter, WithRouterProps } from 'react-router';
import ControlledInput from '@reverbdotcom/commons/src/components/controlled_input';
import { SearchRemixer_FacetGroupFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';
import { useUpdateUrl } from '@reverbdotcom/commons/src/components/with_update_url';

export interface RangeFacetInnerProps {
  facetGroup: SearchRemixer_FacetGroupFieldsFragment;
}


function RangeFacetInner({ facetGroup, location, router }: RangeFacetInnerProps & WithRouterProps) {
  const { updateUrl } = useUpdateUrl();
  // Range facet keys have the form *_min and *_max
  const minOption = facetGroup.facets.find(facet => facet.key.endsWith('_min'));
  const maxOption = facetGroup.facets.find(facet => facet.key.endsWith('_max'));

  const [minValue, setMinValue] = useState(minOption ? minOption.paramValue : '');
  const [maxValue, setMaxValue] = useState(maxOption ? maxOption.paramValue : '');
  const [newUrl, setNewUrl] = useState<Partial<Location>>(location);

  useEffect(() => {
    const newParams = { [minOption.key]: minValue, [maxOption.key]: maxValue };

    setNewUrl(updateUrl({
      location,
      newParams,
    }));

  }, [minValue, maxValue, location, minOption?.key, maxOption?.key, updateUrl, setNewUrl]);

  function handleSubmit(event) {
    if (event) event.preventDefault();
    if (newUrl === null) return;
    router.push(newUrl);
  }

  const labelID = `range-facet_${facetGroup.key}-lbl`;

  return (
    <div
      aria-labelledby={labelID}
      className="facet"
      role="group"
    >
      <h3
        className="facet__heading"
        id={labelID}
      >
        {facetGroup.displayName}
      </h3>
      <div className="pt-2">
        <form onSubmit={handleSubmit}>
          <div className="search-input-group__inner">
            <div className="search-input-group__field">
              <ControlledInput
                className="search-input-group__input"
                inputType="number"
                fieldName="minValue"
                inputName="minValue"
                inputValue={minValue}
                updateField={(value) => setMinValue(value.minValue)}
                placeholder="Min"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
              />
            </div>
            <div className="search-input-group__field">
              <ControlledInput
                className="search-input-group__input"
                inputType="number"
                fieldName="maxValue"
                inputName="maxValue"
                inputValue={maxValue}
                updateField={(value) => setMaxValue(value.maxValue)}
                placeholder="Max"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
              />
            </div>
            <button
              className="search-input-group__button"
              type="submit"
              aria-label={I18n.t('commons.forms.submitLabel')}
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default withRouter(RangeFacetInner);
